export default {
    subFieldDelimiter: '_',
    emptyValue: '-',
    countryCodePostfix: 'country-code',
    primitiveProps: ['label', 'validators', 'conditions', 'clearButtonAriaLabel', 'name', 'autocomplete', 'description', 'type', 'maxLength', 'predefinedValue', 'required']
};